import styled, { keyframes, css } from "styled-components";

const blurness = keyframes`
  0%{
    filter:blur(0px);
    transform: scale(1);
    transition-timing-function: cubic-bezier(0.17,0.17, 0,1);
  }
  66%{
    filter:blur(15px);
    transform: scale(0.9572);
    transition-timing-function: cubic-bezier(0.35, 0, 0.2, 1);
  }
  100% {
    transform: scale(0.95);
    filter:blur(15px);
  }
`;

const blurnessReverse = keyframes`
 0%{
   filter:blur(15px);
   transform: scale(0.95);
   transition-timing-function: cubic-bezier(0.35, 0, 0.2, 1);
  }
  100%{
    filter:blur(0px);
    transform: scale(1);
  }
`;
const blurAnim = css`
  ${blurness}
`;
const blurAnimReverse = css`
  ${blurnessReverse}
`;
export const AppContainer = styled.div`
  height: 100%;
  width: 100%;
  ::-webkit-scrollbar {
    display: none;
  }
  & > div ::-webkit-scrollbar {
    display: none;
  }
  pointer-events: ${(p) => (p.isDisabled ? "none" : "auto")};
`;

export const GameContainer = styled.div`
  position: relative;
  backface-visibility: hidden;
  touch-action: manipulation;
`;

export const GameWrapper = styled.div`
  position: relative;
  animation: ${(p) => (!!p.blur ? blurAnim : blurAnimReverse)};
  animation-duration: ${(p) => (!!p.blur ? "0.250s" : "0.367s")};
  animation-fill-mode: forwards;
  backface-visibility: hidden;
  will-change: transform;
  /* overflow: hidden; */
`;
